import React from 'react';
import {Grid, Segment, Image, Header} from 'semantic-ui-react';

export default (props) => {
    var {image, header, subheader, winner, number, number_label, place_label, selectedLanguage} = props;
    return (
        <Grid.Column stretched >
            <Segment style={{padding: 0}} basic>
                <Image draggable="false" src={image} className="circle-image" />
                <Header className="circle-header">
                    <Header.Content style={{padding: "0"}}>
                        <Header.Subheader>
                            <span style={{margin: "0 0.25rem"}}>{selectedLanguage === 'lithuanian'? <span>{number} {place_label}</span> : <span>{number}<sup>{number_label}</sup> {place_label}</span>}</span>
                        </Header.Subheader>
                        <Header.Subheader style={{color: "#2D2D2D", fontSize: "15pt", fontWeight: 500}}>
                            <span style={{margin: "0 0.25rem"}}>{winner}</span>
                        </Header.Subheader>
                        {/* <b style={{color: "#E21F14", margin: "0 0.25rem", fontWeight: 900, fontSize: "15pt"}}>{header}</b>
                        <Header.Subheader style={{color: "#2D2D2D"}}>
                            <span style={{margin: "0 0.25rem"}}>{subheader}</span>
                        </Header.Subheader> */}
                    </Header.Content>
                </Header>
            </Segment>
        </Grid.Column>
    )
}


// WEBPACK FOOTER //
// ./src/components/prizes/Prize.jsx